export { default } from './CardMedia';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CardMedia/index.js
// module id = 818
// module chunks = 2